// src/pages/ChampionsWithoutBorders.tsx
//
// "أبطال بلا حدود" / "Champions Without Borders" — a new initiative currently
// in progress. Added as a titled placeholder for now; real content TBD.

import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Globe, Sparkles } from 'lucide-react';
import { PageHero } from '@/components/PageHero';

const ChampionsWithoutBorders = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const L = (ar: string, en: string) => (isRTL ? ar : en);

  return (
    <div className="min-h-screen">
      <PageHero
        title={L('أبطال بلا حدود', 'Champions Without Borders')}
        subtitle={L(
          'مبادرة جديدة قيد الإعداد — ترقّبوا التفاصيل قريبًا.',
          'A new initiative in the works — details coming soon.',
        )}
        breadcrumbs={[
          { label: L('الرئيسية', 'Home'), path: '/' },
          { label: L('أبطال بلا حدود', 'Champions Without Borders') },
        ]}
      />

      <section className="container mx-auto px-4 py-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mx-auto flex max-w-2xl flex-col items-center text-center"
        >
          <div className="relative mb-8 flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-br from-primary to-accent shadow-2xl shadow-primary/30">
            <Globe className="h-11 w-11 text-primary-foreground" />
            <Sparkles className="absolute -top-1 -end-1 h-6 w-6 text-accent" />
          </div>

          <h2 className="mb-4 text-3xl font-bold gradient-text">
            {L('قريبًا', 'Coming Soon')}
          </h2>

          <p className="text-lg leading-relaxed text-muted-foreground">
            {L(
              'نعمل حاليًا على إطلاق مبادرة «أبطال بلا حدود». سيتم إضافة المحتوى الكامل قريبًا.',
              'We are currently building the “Champions Without Borders” initiative. Full content will be added soon.',
            )}
          </p>
        </motion.div>
      </section>
    </div>
  );
};

export default ChampionsWithoutBorders;
